import { render, staticRenderFns } from "./priceMark.vue?vue&type=template&id=77021078&scoped=true&"
import script from "./priceMark.vue?vue&type=script&lang=js&"
export * from "./priceMark.vue?vue&type=script&lang=js&"
import style0 from "./priceMark.vue?vue&type=style&index=0&id=77021078&prod&lang=scss&scoped=true&"
import style1 from "./priceMark.vue?vue&type=style&index=1&id=77021078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77021078",
  null
  
)

export default component.exports